unit NetItemListType;
{

/* Initial. */

}
interface

uses
  NetItemType;

type
  TNetItemListType = array of TNetItemType;

implementation

end.
